<script>
	import { Table, DropdownItem } from "sveltestrap";
	import { navigate } from "svelte-routing";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { convert } from "../../../services/helpers";
	import client from "../../../services/client";
	import { loading } from "../../../store/store";
	import { carStatusMap } from "../../../utils/options";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";
	import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown.svelte";
	export let data;
	export let fetchVehicles;
	export let lookups;

	let wrapperEl;
	let extraPad = 0;
	let isCarStatusOpen = -1;


	// handles menuRect event from CustomDropdown
	// if dropdown menu spills past the bottom of the table wrapper, add extra padding
	function onMenuRect(e) {
		const menuRect = e.detail; // bounding rect of the dropdown menu
		const wrapRect = wrapperEl.getBoundingClientRect(); // bounding rect of the wrapper

		// calc overflow of the dropdown menu
		const overflow = menuRect.bottom - wrapRect.bottom;

		// set extra padding if dropdown menu overflows table wrapper
		extraPad = Math.max(0, Math.ceil(overflow));
	}

	async function handleCarStatus(id, status) {
		try {
			if (status === 0) {
				status = false;
			} else {
				status = true;
			}
			loading.set(true);
			const res = await client("/v1/status", {
				method: "PUT",
				version: "Vehicle",
				data: {
					id,
					status,
				},
			});
			if (res.status === 200) {
				fetchVehicles();
			}
		} catch (err) {
			console.log(err);
		}
	}

	async function changeCarStatus(vehicleId, status) {
		try {
			const res = await client(`/v2/${vehicleId}/status`, {
				method: "PUT",
				version: "Vehicle",
				data: {
					statusId: status,
				},
			});
			await fetchVehicles();
			return res;
		} catch (error) {
			console.log(error);
		}
	}

	function toggleCarStatus(idx) {
		if (idx === isCarStatusOpen) {
			isCarStatusOpen = -1;
			extraPad = 0; // reset extra padding when closing dropdown
			return;
		}
		isCarStatusOpen = idx;
		extraPad = 0; // reset extra padding after opening dropdown
		return;
	}
</script>

<LoaderContainer>
	<div class="table-responsive" bind:this={wrapperEl} style="padding-bottom: {extraPad}px;">
		<Table hover>
			<thead>
				<tr>
					<th>Vehicle No.</th>
					<th>Make</th>
					<th>Model</th>
					<th>Carpark</th>
					<th>Pricing Group</th>
					<th>Active Start Date</th>
					<th>Active End Date</th>
					<th>Status</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				{#each data as { id, vehicleMakeName, vehicleModelName, carParkId, carParkName, plateNumber, priceGroupName, activeFrom, activeTo, status, vehicleStatusId }, rowIndex}
					<tr>
						<td>
							<p
								on:click={() =>
									navigate(`/car-management/details/${id}`)}
								on:keydown={() => {}}
							>
								<span class="link link-text">
									{plateNumber}
								</span>
							</p>
						</td>
						<td>
							<p>
								<span> {vehicleMakeName} </span>
							</p>
						</td>
						<td>
							<p>
								<span> {vehicleModelName} </span>
							</p>
						</td>
						<td>
							<p
								class="link"
								on:click={() =>
									navigate(
										`/carpark-management/details/${carParkId}`
									)}
								on:keydown={() => {}}
							>
								<span class="link link-text">
									{carParkName}
								</span>
							</p>
						</td>
						<td>
							<p>
								<span> {priceGroupName} </span>
							</p>
						</td>
						<td>
							<p>
								<span>{convert(activeFrom)} </span>
							</p>
						</td>
						<td>
							<p>
								<span> {convert(activeTo)} </span>
							</p>
						</td>
						<td>
							<!-- {@html carStatusMap[status]} -->
							<CustomDropdown
								options={lookups.vehicleStatuses}
								toggle={() => toggleCarStatus(rowIndex)}
								isOpen={isCarStatusOpen === rowIndex}
								value={vehicleStatusId}
								handleSelect={changeCarStatus}
								on:menuRect={(e) => onMenuRect(e)}
								{id}
							/>
						</td>
						<td>
							<TableDropdown>
								<DropdownItem
									on:click={() =>
										navigate(
											`/car-management/details/${id}`
										)}>View Details</DropdownItem
								>
							</TableDropdown>
						</td>
					</tr>
				{/each}
			</tbody>
		</Table>
	</div>
	{#if data.totalCount == 0}
		<p class="text-center">No data to display</p>
	{/if}
	<Pagination totalRecord={data.totalCount} />
	<CustomModal />
</LoaderContainer>